import React, { useState, useEffect } from "react";

// Imágenes en public/assets/
const csgoLogo = "/assets/csgo-logo.png";
const bannerBg = "/assets/banner-bg.png";

const Banner = ({ contractAddress = "" }) => {
    const [copied, setCopied] = useState(false);
    const [showContract, setShowContract] = useState(!!contractAddress);

    useEffect(() => {
        setShowContract(!!contractAddress);
    }, [contractAddress]);

    const handleCopy = async () => {
        if (!contractAddress) return;
        
        try {
            await navigator.clipboard.writeText(contractAddress);
            setCopied(true);
            
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };

    const flapLink = contractAddress 
        ? `https://flap.sh/bnb/${contractAddress}` 
        : "https://flap.sh/bnb/";

    const truncateAddress = (address) => {
        if (!address) return "";
        if (address.length <= 16) return address;
        return `${address.slice(0, 8)}...${address.slice(-8)}`;
    };

    return (
        <div className="top-banner">
            {/* Background Image */}
            <div 
                className="banner-bg-image"
                style={{ backgroundImage: `url(${bannerBg})` }}
            ></div>
            <div className="banner-glow"></div>
            
            <div className="banner-content">
                {/* Twitter Link */}
                <a 
                    href="https://x.com/CsgoFlap" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="banner-link twitter-link"
                >
                    <svg viewBox="0 0 24 24" className="banner-icon">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                    <span>Twitter</span>
                </a>

                {/* Flap Link with CS:GO Logo */}
                <a 
                    href={flapLink}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="banner-link flap-link"
                >
                    <img 
                        src={csgoLogo} 
                        alt="CS:GO" 
                        className="flap-logo"
                    />
                    <span>Flap</span>
                </a>

                {/* Contract Address */}
                {showContract && contractAddress && (
                    <div 
                        className={`contract-container ${copied ? 'copied' : ''}`}
                        onClick={handleCopy}
                    >
                        <div className="contract-label">CONTRACT</div>
                        <div className="contract-address">
                            <span className="address-text">{truncateAddress(contractAddress)}</span>
                            <svg viewBox="0 0 24 24" className="copy-icon">
                                {copied ? (
                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                ) : (
                                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                                )}
                            </svg>
                        </div>
                        <div className="copy-tooltip">{copied ? '¡Copiado!' : 'Click para copiar'}</div>
                        {copied && <div className="copy-ripple"></div>}
                    </div>
                )}
            </div>
            
            <div className="banner-particles">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className={`particle particle-${i + 1}`}></div>
                ))}
            </div>
        </div>
    );
};

export default Banner;
